import React from 'react';

const About = () => {
  return (
    <section className="relative px-8 py-16 overflow-hidden bg-gradient-to-r from-purple-100 via-blue-100 to-green-100">
      {/* SVG Pattern Background */}
      <div className="absolute inset-0 w-full h-full -z-10">
        <svg className="w-full h-full" viewBox="0 0 1440 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <defs>
            <pattern id="dots" patternUnits="userSpaceOnUse" width="40" height="40" patternTransform="rotate(45)">
              <circle cx="10" cy="10" r="2" fill="#3B82F6" opacity="0.1" />
            </pattern>
          </defs>
          <rect width="1440" height="800" fill="url(#dots)" />
        </svg>
      </div>

      {/* Content Container */}
      <div className="relative z-20 grid items-center gap-12 mx-auto max-w-7xl md:grid-cols-2">
        {/* Text Section */}
        <div className="p-8 transition duration-300 ease-in-out transform bg-white shadow-lg bg-opacity-90 rounded-xl backdrop-blur-lg hover:scale-105">
          <h2 className="mb-4 text-4xl font-extrabold text-gray-800">About Blessed Montessori</h2>
          <p className="mb-6 text-lg text-gray-600">
            Blessed Montessori is a globally minded institution nurturing excellence, creativity, and leadership. With a blend of modern learning methods and timeless values, we empower students to thrive academically and grow into compassionate global citizens.
          </p>
          <div className="space-y-6">
            {/* Feature 1 */}
            <div className="flex items-center p-4 space-x-4 transition-shadow duration-300 rounded-lg shadow-md bg-gradient-to-tr from-purple-200 via-blue-200 to-green-200 hover:shadow-xl">
              <div className="p-3 transition duration-300 transform bg-white rounded-full shadow-lg hover:scale-110">
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17 20v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2H17z" />
                  <circle cx="12" cy="8" r="4" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700">Exceptional Educators</h3>
                <p className="text-sm text-gray-500">Our passionate teachers inspire minds and mentor students with care and experience.</p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex items-center p-4 space-x-4 transition-shadow duration-300 rounded-lg shadow-md bg-gradient-to-tr from-purple-200 via-blue-200 to-green-200 hover:shadow-xl">
              <div className="p-3 transition duration-300 transform bg-white rounded-full shadow-lg hover:scale-110">
                <svg className="w-6 h-6 text-yellow-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 21h6v-1H9v1zm3-18a4 4 0 00-4 4c0 1.38.56 2.63 1.46 3.54A5.978 5.978 0 009 12h6a5.978 5.978 0 00-1.46-3.46A4 4 0 0015 7a4 4 0 00-4-4z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700">Future-Ready Learning</h3>
                <p className="text-sm text-gray-500">We blend innovation with tradition, preparing our learners for tomorrow’s world today.</p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="flex items-center p-4 space-x-4 transition-shadow duration-300 rounded-lg shadow-md bg-gradient-to-tr from-purple-200 via-blue-200 to-green-200 hover:shadow-xl">
              <div className="p-3 transition duration-300 transform bg-white rounded-full shadow-lg hover:scale-110">
                <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 14c-1.33 0-2.53.53-3.41 1.39A4.993 4.993 0 0012 20c1.33 0 2.53-.53 3.41-1.39A4.993 4.993 0 0016 14zM8 14c-1.33 0-2.53.53-3.41 1.39A4.993 4.993 0 004 20c1.33 0 2.53-.53 3.41-1.39A4.993 4.993 0 008 14zM12 4c-2.21 0-4 1.79-4 4 0 1.66 1.34 3 3 3h2c1.66 0 3-1.34 3-3 0-2.21-1.79-4-4-4z" />
                </svg>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700">Inclusive & Caring</h3>
                <p className="text-sm text-gray-500">We create a nurturing environment where every child is seen, supported, and celebrated.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="relative p-4">
          <div className="absolute inset-0 transition-transform duration-300 transform shadow-lg bg-gradient-to-br from-purple-400 via-blue-400 to-green-400 rounded-xl hover:scale-105"></div>
          <img
            src="https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&w=800&q=80"
            alt="Blessed Montessori Classroom"
            className="relative object-cover w-full h-full transition-opacity duration-300 shadow-xl rounded-xl hover:opacity-90"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
